import { useEffect, useState } from "react";

import ListGroup from "react-bootstrap/ListGroup";

import Checkmark from "/src/components/common/Icon/Checkmark";

import { useIsFirstRender } from "/src/components/hooks/first_render.js";

const ListFilter = ({ placeholder="Select", isMulti, onChange, options=[], value }) => {

  const isFirstRender = useIsFirstRender();
  const [uncontrolledValue, setUncontrolledValue] = useState(value);

  // Size
  const getBootstrapSize = () => {
    return "sm";
  }
  // End Size

  useEffect(() => {
    if (isFirstRender) {
      return;
    }
    if (typeof onChange === "function") {
      onChange(uncontrolledValue);
    }
  }, [uncontrolledValue]);

  useEffect(() => {
    setUncontrolledValue(value);
  }, [value]);

  const onUpdate = (option) => {
    let newValue;
    if (isMulti) {
      newValue = [...(uncontrolledValue || [])];
      if (isSelected(option)) {
        let deleteIndex = newValue.findIndex(item => item.value === option.value);
        newValue.splice(deleteIndex, 1);
      }
      else {
        newValue.push(option);
      }
    }
    else {
      newValue = JSON.stringify(value) === JSON.stringify(option) ? null : option;
    }
    setUncontrolledValue(newValue);
  }

  const getValue = () => {
    let finalValue = value;
    if (typeof finalValue === "undefined") {
      finalValue = uncontrolledValue;
    }
    return finalValue;
  }

  const isSelected = (option) => {
    let finalValue = getValue();
    if (finalValue) {
      finalValue = Array.isArray(finalValue) ? finalValue : [finalValue];
      return finalValue.find(item => item.value === option.value);
    }
  }

  const renderOption = (option) => {
    let classNames = ["m-0 cursor-pointer"].concat(isSelected(option) ? [""] : []);
    return (
      <ListGroup.Item
        key={option.value}
        className={classNames.join(" ")}
        onClick={() => onUpdate(option)}
      >
        <div className="d-flex flex-row justify-content-between align-items-center">
          <div className={option.className}>
            {option.label}
          </div>
          {isSelected(option) && <Checkmark />}
        </div>
      </ListGroup.Item>
    );
  }

  const renderOptions = () => {
    return options.map(item => renderOption(item));
  }

  return (
    <ListGroup variant="flush" className="rounded-4">
      {renderOptions()}
    </ListGroup>
  );

}

export default ListFilter;
